import { ApiRegistrationParticipantForParticipantResponse } from "shared/types/ApiRegistrationParticipantForParticipantResponse";
import PurchaseConfirmation from "../../../../../../shared/components/purchaseOrder/components/purchaseConfirmation";
import { ConfirmationPageEntityType } from "../../../../../../shared/components/purchaseOrder/components/enum";
import React from "react";
import { isApprovalPending } from "../../../purchaseTicket/util";
import { useParticipantDetails } from "../../../../context/participantDetails";
import { getFullName } from "../../../../../../shared/utils";
import useNavigateWrapper from "../../../../../../shared/hooks/useNavigateWrapper";
import { MyExpRoute } from "apps/myExperience/routes/types";
import { isPaymentReceiptPendingForPO } from "apps/myExperience/utils";
import ApiPurchaseOrder from "shared/model/ApiPurchaseOrder";

export default function ConfirmationView(props: {
  ticketUpgradeFormDetails: ApiRegistrationParticipantForParticipantResponse;
  purchaseOrder: ApiPurchaseOrder;
}) {
  const { navigate } = useNavigateWrapper();
  const { participantDetails } = useParticipantDetails();
  const pendingApproval = React.useMemo(
    () =>
      isApprovalPending(props.ticketUpgradeFormDetails.ticketStatus) ||
      isPaymentReceiptPendingForPO(props.purchaseOrder),
    [props.ticketUpgradeFormDetails.ticketStatus, props.purchaseOrder]
  );

  return (
    <div className="tckUpgradeConfirmation">
      <PurchaseConfirmation
        participantFullName={getFullName({
          firstName: participantDetails?.firstName as string,
          lastName: participantDetails?.lastName as string
        })}
        approvalPending={pendingApproval}
        entityType={ConfirmationPageEntityType.TICKET_CHANGE}
        purchaseOrder={props.purchaseOrder}
        purchaseOrderTableProps={{
          originatingFormName: props.ticketUpgradeFormDetails.registrationForm.title
        }}
        ticketStatus={props.ticketUpgradeFormDetails.ticketStatus}
        myExperienceLoginUrl={props.ticketUpgradeFormDetails.myExperienceLoginUrl}
        closeHandler={() => navigate(MyExpRoute.HOME.path)}
      />
    </div>
  );
}
